import * as React from 'react';
import {
  useLocation,
  Navigate,
  useParams,
  useNavigate,
} from 'react-router-dom';
import { useUser } from './data/useUser';
import CircularProgress from '@mui/material/CircularProgress';

const AuthContext = React.createContext();
const AccountContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const userQuery = useUser();

  // TODO: add 'error' in the case of non-401 API errors?

  const value = { isLoading: userQuery.isLoading, user: userQuery.data };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return React.useContext(AuthContext);
};

export const RequireAuth = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (auth.isLoading) {
    return <CircularProgress />;
  }

  if (!auth.user) {
    navigate('/login', { replace: true, state: { from: location } });
    // return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export const AccountProvider = ({ children }) => {
  const params = useParams();
  const [currentAccount, setCurrentAccount] = React.useState(null);

  let lastSelectedAccount;
  try {
    lastSelectedAccount = JSON.parse(localStorage.getItem('currentAccount'));
  } catch (e) {
    lastSelectedAccount = null;
  }
  const auth = useAuth();

  if (!currentAccount) {
    if (auth?.user?.roles?.length > 0) {
      if (params.accountId) {
        for (let role of auth.user.roles) {
          if (
            role.account.id === params.accountId ||
            role.account.name === params.accountId
          ) {
            setCurrentAccount(role.account);
            break;
          }
        }
      } else if (lastSelectedAccount?.account) {
        setCurrentAccount(lastSelectedAccount.account);
      } else {
        setCurrentAccount(auth.user.roles[0].account);
      }
    }
  }

  const switchAccount = (account) => {
    setCurrentAccount(account);
    localStorage.setItem('currentAccount', JSON.stringify({ account }));
  };

  const value = {
    isLoading: auth.isLoading,
    currentAccount,
    switchAccount,
  };

  return (
    <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
  );
};

export const useAccount = () => {
  return React.useContext(AccountContext);
};

export const RequireAccount = ({ children }) => {
  const params = useParams();
  const auth = useAuth();
  const { currentAccount } = useAccount();
  const location = useLocation();
  const navigate = useNavigate();

  if (auth.isLoading) {
    return <CircularProgress />;
  }

  if (!auth.user) {
    navigate('/login', { replace: true, state: { from: location } });
    return;
    // return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    !params.accountId &&
    currentAccount &&
    location.pathname != `/${currentAccount.name}/flows`
  ) {
    navigate(`/${currentAccount.name}/flows`);
    return;
  }

  if (!currentAccount) {
    return <h2>You don't have access to an Aquifer account</h2>;
  }

  return children;
};
